import isEmpty from 'lodash/isEmpty';

export async function getTypeByCategoryId({commit}, categoryIds) {
  if (isEmpty(categoryIds)) {
    commit('setTypes', []);
    return [];
  }

  const response = await this.$frontendRepositories.documents.getTypeByCategoryId(categoryIds);
  if (!response.errResponse && response.data.success) {
    commit('setTypes', response.data.data);
    return response;
  }

  commit('setTypes', []);
  return [];
}

export async function getMetaCommon({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.getMetaCommon();
  if (!errResponse && responseData.success) {
    return commit('setMetaCommon', responseData.data);
  }

  return commit('setMetaCommon', []);
}

export async function uploadToTmpStorage({commit}, payload) {
  return await this.$frontendRepositories.documents.uploadToTmpStorage(payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export async function bulkUploadToTmpStorage({commit}, payload) {
  return await this.$frontendRepositories.documents.bulkUploadToTmpStorage(payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export async function uploadDocument({commit}, formData) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.upload(formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  commit('hidePageLoading', true, {root: true});
  return response;
}

export async function saveDocumentAsDraft({commit}, formData) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.saveDocumentAsDraft(formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  commit('hidePageLoading', true, {root: true});
  return response;
}

export async function getDraftDocumentUpload({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.getDraftDocumentUpload();
  return commit('setDraftDocuments', errResponse || !responseData.success ? [] : responseData.data);
}

export async function findDraftDocumentById({commit}, id) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.findDraftDocumentById(id);
  const {errResponse, data: responseData} = response;
  commit('hidePageLoading', false, {root: true});
  commit('setDraftDocumentItem', errResponse || !responseData.success ? {} : responseData.data);
  return response;
}

export async function deleteDraftDocumentById({commit, dispatch}, id) {
  const response = await this.$frontendRepositories.documents.deleteDraftDocumentById(id);
  await dispatch('getDraftDocumentUpload');
  return response;
}

export async function updateDocument({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.update(payload.id, payload.formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function getListCategory({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.getDocumentData(payload);

  if (!errResponse && responseData.success) {
    commit('setCategories', responseData.data);

    return responseData.data;
  }

  commit('setCategories', []);

  return [];
}

export async function getChildren(_, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.getNodes(payload);

  if (!errResponse && responseData.success) {
    return responseData.data;
  }

  return [];
}

export async function generateShareToken(_, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.generateShareToken(payload || null);
  return errResponse ? null : responseData.data.token;
}

export async function shareDocument({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.share(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findSharedDocument({commit}, token) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.findSharedDocument(token);
  if (!errResponse && responseData.success) {
    const unlockStatus = !responseData.data.has_password;
    commit('setUnlockSharedDocument', unlockStatus);
    return commit('setSharedDocument', responseData.data);
  }
}

export async function unlockPassword({commit}, payload) {
  commit('showPageLoading', payload, {root: true});
  const response = await this.$frontendRepositories.documents.unlockPassword(payload);
  commit('hidePageLoading', payload, {root: true});
  if (!response.errResponse) {
    commit('setUnlockSharedDocument', response.data.data.unlockSharedDocument);
  }
  return response;
}

export async function deleteDocument(_, documentIds) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.deleteDocuments(documentIds);

  return errResponse ? false : responseData.data;
}

export async function findDocumentById({commit}, payload) {
  const response = await this.$frontendRepositories.documents.show(payload);
  const {errResponse, data: responseData} = response;

  if (!errResponse && responseData.success) {
    commit('setDocument', responseData.data);
  }

  return response;
}

export async function deleteSingleDocument(_, payload) {
  return await this.$frontendRepositories.documents.delete(payload);
}

/* Comments */
export async function findCommentsByDocumentId({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.findCommentsByDocumentId(payload);
  if (!errResponse && responseData.success) {
    return commit('setComments', responseData.data);
  }

  return [];
}

export async function storeComment({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.documents.storeComment(payload);
  if (!errResponse && responseData.success) {
    return commit('setComments', responseData.data);
  }

  return [];
}

export async function deleteComment({dispatch}, payload) {
  const response = await this.$frontendRepositories.documents.deleteComment(payload.id);
  dispatch('findCommentsByDocumentId', payload.document_id);
  return response;
}

/* Approve func */
export async function approveDocument({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.approveDocument(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function checkCanEdit(_, payload) {
  return this.$frontendRepositories.documents.checkCanEdit(payload);
}

export async function getBulkUploadDocumentFromRedis({commit}) {
  const response = await this.$frontendRepositories.documents.getBulkUploadDocumentFromRedis();
  const {errResponse, data: responseData} = response;
  commit('setBulkUploadList', errResponse || !responseData.success ? [] : Object.values(responseData.data));
  return response;
}

export async function findBulkUploadDocumentByIdFromRedis({commit}, id) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$frontendRepositories.documents.findBulkUploadDocumentByIdFromRedis(id);
  const {errResponse, data: responseData} = response;
  commit('setBulkUploadItem', errResponse || !responseData.success ? {} : responseData.data);
  commit('hidePageLoading', true, {root: true});
  return response;
}

export async function getDownloadHistory({commit}, id) {
  const {data: responseData} = await this.$frontendRepositories.documents.getDownloadHistory(id);

  if (responseData.success) {
    commit('setDownloadHistory', responseData.data);
  }
}

export async function getListMeApproveRequest(_) {
 return await this.$frontendRepositories.documents.getListMeApproveRequest();
}

export async function getListApproveRequest(_) {
 return await this.$frontendRepositories.documents.getListApproveRequest();
}

export async function getLisDashboardApproveRequest({commit}) {
  const response = await this.$frontendRepositories.documents.getListDashboardApproveRequest();
  if (response?.data?.success) {
    commit('setdashboardDocumentData', response.data.data)
  }
}